import {
  getAttachmentBase64,
  getAttachments,
  postAttachment,
  putAttachment,
} from "../../api/attachments";
import { createSliceWithThunks } from "../utils";

const initialState = {
  payload: [],
  get: {
    list: null,
    status: "idle",
    error: null,
  },
  getBase64: {
    list: null,
    status: "idle",
    error: null,
  },
  post: {
    data: null,
    status: "idle",
    error: null,
  },
  put: {
    data: null,
    status: "idle",
    error: null,
  },
};

export const attachmentSlice = createSliceWithThunks({
  name: "attachmentSlice",
  initialState: initialState,
  reducers: (create) => ({
    resetStateAttachments: create.reducer((state, { payload }) => {
      if (payload) {
        for (let key in payload) {
          state[`${payload[key]}`] = initialState[`${payload[key]}`];
        }
      } else {
        for (let key in initialState) {
          state[key] = initialState[key];
        }
      }
    }),
    setAttachmentsValues: create.reducer((state, { payload }) => {
      state.payload = payload;
    }),
    //* thunks
    fetchAttachments: create.asyncThunk(
      async (payload, { rejectWithValue }) => {
        try {
          const response = await getAttachments(payload);
          return response;
        } catch (err) {
          return rejectWithValue(err.message);
        }
      },
      {
        pending: (state) => {
          state.get.status = "loading";
        },
        rejected: (state, action) => {
          state.get.status = "failed";
          state.get.error = action.error;
        },
        fulfilled: (state, { payload }) => {
          const { status, data } = payload;
          if (status === 200) {
            let { status, data: respObj } = data;
            if (status === "error") {
              state.get.error = { message: respObj };
            } else if (status === "success") {
              state.get.list = respObj;
            }
          } else {
            state.get.error = {
              message: data?.message || "An error occurred",
            };
          }
          state.get.status = "idle";
        },
      }
    ),
    fetchAttachmentBase64: create.asyncThunk(
      async (payload, { rejectWithValue }) => {
        try {
          const response = await getAttachmentBase64(payload);
          return response;
        } catch (err) {
          return rejectWithValue(err.message);
        }
      },
      {
        pending: (state) => {
          state.getBase64.status = "loading";
        },
        rejected: (state, action) => {
          state.getBase64.status = "failed";
          state.getBase64.error = action.error;
        },
        fulfilled: (state, { payload }) => {
          const { status, data } = payload;
          if (status === 200) {
            let { status, data: respObj } = data;
            if (status === "error") {
              state.getBase64.error = { message: respObj };
            } else if (status === "success") {
              state.getBase64.list = respObj;
              state.getBase64.error = null;
            }
          } else {
            state.getBase64.error = {
              message: data?.message || "An error occurred",
            };
          }
          state.getBase64.status = "idle";
        },
      }
    ),
    addAttachment: create.asyncThunk(
      async (payload, { rejectWithValue }) => {
        try {
          const response = await postAttachment(payload);
          return response;
        } catch (err) {
          return rejectWithValue(err.message);
        }
      },
      {
        pending: (state) => {
          state.post.status = "loading";
        },
        rejected: (state, action) => {
          state.post.status = "failed";
          state.post.error = action.error;
        },
        fulfilled: (state, { payload }) => {
          const { status, data } = payload;
          if (status === 200) {
            let { status, data: respObj } = data;
            if (status === "error") {
              state.post.error = { message: respObj };
            } else if (status === "success") {
              state.post.data = respObj;
            }
          } else {
            state.post.error = {
              message: data?.message || "An error occurred",
            };
          }
          state.post.status = "idle";
        },
      }
    ),
    updateAttachment: create.asyncThunk(
      async (payload, { rejectWithValue }) => {
        try {
          const response = await putAttachment(payload);
          return response;
        } catch (err) {
          return rejectWithValue(err.message);
        }
      },
      {
        pending: (state) => {
          state.put.status = "loading";
        },
        rejected: (state, action) => {
          state.put.status = "failed";
          state.put.error = action.error;
        },
        fulfilled: (state, { payload }) => {
          const { status, data } = payload;
          if (status === 200) {
            let { status, data: respObj } = data;
            if (status === "error") {
              state.put.error = { message: respObj };
            } else if (status === "success") {
              state.put.data = respObj;
            }
          } else {
            state.put.error = {
              message: data?.message || "An error occurred",
            };
          }
          state.put.status = "idle";
        },
      }
    ),
  }),
});

export const {
  fetchAttachments,
  fetchAttachmentBase64,
  addAttachment,
  updateAttachment,
  resetStateAttachments,
  setAttachmentsValues,
} = attachmentSlice.actions;
export default attachmentSlice.reducer;
